import styled, {css} from 'styled-components';

export const StyledIconButton = styled.button`
  background-color: transparent;
  border: 0;
  cursor: pointer;
  color: ${({ theme }) => theme.button.backgroundColor};
  text-transform: uppercase;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;

  ${({ red }) => red && css`color: ${({ theme }) => theme.palette.danger[1]};`}
  ${({ variant }) => variant === 'primary' && css`
    background-color: ${({ theme }) => theme.button.backgroundColor};
    color: ${({ theme }) => theme.palette.white[0]};
  `}

  > svg {
    margin-right: 0.3rem;
    font-size: 1rem;
    opacity: 1;
    
    &:enabled:hover {
      opacity: .7;
    }
  }

  &:last-child {
    margin-right: 0;
  }

  &:focus {
    outline: none;
  }

  &:disabled {
    color: ${({ theme }) => theme.palette.grayscale[3]};
    cursor: unset;
  }
  
  &:hover {
    opacity: 0.9;
  }
`;
